<script>
  export default {
    name: 'FooterTitle',
  }
</script>

<template>
  <h5><slot/></h5>
</template>

<style lang="scss" scoped>
h5 {
  font-size: rem-calc(22);
  margin-top: 0;
  margin-bottom: rem-calc(20);
}
</style>


// WEBPACK FOOTER //
// src/components/FooterTitle.vue